import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { GenericLinkDirective, SafeCheckPipe } from '@boels/helpers';
import { CmsComponentData, SplitBannerComponentData } from '@boels/models';
import { ComponentDataService } from '@boels/shared-state';
import { ButtonComponent } from '../button/button.component';

@Component({
  imports: [CommonModule, SafeCheckPipe, ButtonComponent, GenericLinkDirective],
  selector: 'boels-split-banner',
  templateUrl: './split-banner.component.html',
  styleUrls: ['./split-banner.component.scss'],
})
export class SplitBannerComponent {
  private componentDataService = inject(ComponentDataService);

  @Input() componentData: CmsComponentData<SplitBannerComponentData>;

  getImageSrc(url = ''): string {
    return this.componentDataService.getImageSrc(url);
  }
}
